import { NotificationsFeedContainer } from "@/features/deployment-dashboard";

export function NotificationsRoute() {
  return <NotificationsFeedContainer />;
}
